import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import companies from './companies'
import companyDirectorShares from './companyDirectorShares'
import dashboard from './dashboard'
import dashboardSearch from './dashboardSearch'
import jobTitlesSearch from './jobTitlesSearch'
import directors from './directors'
import directorRanking from './directorRanking'
import companyRanking from './companyRanking'
import executiveRanking from './executiveRanking'
import analyseOptions from './analyseOptions'
import analyser from './analyser'
import industryClassifications from './industryClassifications'
import superannuationClassifications from './superannuationClassifications'
import superannuations from './superannuations'
import skillDiversities from './skillDiversities'
import searches from './searches'
import searchResults from './searchResults'
import users from './users'
import userReports from './userReports'
import companyExecutives from './companyExecutives'
import superannuationExecutives from './superannuationExecutives'
import remunerationAnalyseOptions from './remunerationAnalyseOptions'
import remunerationAnalyser from './remunerationAnalyser'
import statisticsOptions from './statisticsOptions'
import statisticsResults from './statisticsResults'
import governments from './governments'
import governmentExecutives from './governmentExecutives'
import minorGovernments from './minorGovernments'
import minorGovernmentExecutives from './minorGovernmentExecutives'
import bookmarkFolders from './bookmarkFolders'
import bookmarks from './bookmarks'
import executiveChanges from './executiveChanges'
import executiveRisks from './executiveRisks'
import ceoRisks from './ceoRisks'
import ceoMidSmallRisks from './ceoMidSmallRisks'
import executiveRiskDetails from './executiveRiskDetails'
import directorRankingPerformance from './directorRankingPerformance'
import companyRisks from './companyRisks'
import topCompanyRisks from './topCompanyRisks'
import executiveDepartures from './executiveDepartures'
import executiveArrivals from './executiveArrivals'
import nonExecDirectorRenewals from './nonExecDirectorRenewals'
import nonExecDirectorChanges from './nonExecDirectorChanges'
import connectionList from './connectionList'
import connectionHistory from './connectionHistory'
import linkWithOthers from './linkWithOthers'
import dataVisualizations from './dataVisualizations'
import privateCompanies from './privateCompanies'
import privateCompanyExecutives from './privateCompanyExecutives'
import nfps from './nfps'
import nfpExecutives from './nfpExecutives'
import notifications from './notifications'
import entitySearches from './entitySearches'
import boardDetailsSearch from './boardDetailsSearch'
import futureRemunerations from './futureRemunerations'
import futureRemFilters from './futureRemFilters'
import futureRemCalculations from './futureRemCalculations'
import committeeMemberships from './committeeMemberships'
import remunerations from './remunerations'
import remFilters from './remFilters'
import memberDirectors from './memberDirectors'
import superannuationDataVisualizations from './superannuationDataVisualizations'
import newJob from './newJob'
import jobs from './jobs'
import jobApplications from './jobApplications'
import updateJob from './updateJob'
import advertisements from './advertisements'
import ceos from './ceos'
import ceoRemunerationComponents from './ceoRemunerationComponents'
import remunerationInformations from './remunerationInformations'
import remunerationPolicies from './remunerationPolicies'
import boardPolicies from './boardPolicies'
import peerComparisonReport from './peerComparisonReport'
import listedCompanies from './listedCompanies'
import yourCompany from './yourCompany'
import executiveRisk from './executiveRisk'
import superAnnuationTab from './superAnnuationTab';
import governmentTab from './governmentTab';
import otherGovernmentTab from './otherGovernmentTab';
import notForProfitTab from './notForProfitTab'
import privateCompaniesTab from './privateCompaniesTab';
import allCompaniesTab from "./allCompaniesTab";

export default (history) => combineReducers({
    companies,
    companyDirectorShares,
    dashboard,
    dashboardSearch,
    jobTitlesSearch,
    directors,
    directorRanking,
    companyRanking,
    executiveRanking,
    analyseOptions,
    analyser,
    industryClassifications,
    superannuationClassifications,
    superannuations,
    skillDiversities,
    searches,
    searchResults,
    users,
    userReports,
    companyExecutives,
    superannuationExecutives,
    remunerationAnalyseOptions,
    remunerationAnalyser,
    statisticsOptions,
    statisticsResults,
    governments,
    governmentExecutives,
    minorGovernments,
    minorGovernmentExecutives,
    bookmarkFolders,
    bookmarks,
    executiveChanges,
    directorRankingPerformance,
    executiveRisks,
    ceoRisks,
    ceoMidSmallRisks,
    executiveRiskDetails,
    companyRisks,
    topCompanyRisks,
    executiveDepartures,
    nonExecDirectorRenewals,
    nonExecDirectorChanges,
    connectionList,
    connectionHistory,
    linkWithOthers,
    dataVisualizations,
    privateCompanies,
    privateCompanyExecutives,
    nfps,
    nfpExecutives,
    notifications,
    entitySearches,
    boardDetailsSearch,
    futureRemunerations,
    futureRemFilters,
    futureRemCalculations,
    committeeMemberships,
    remunerations,
    remFilters,
    memberDirectors,
    executiveArrivals,
    superannuationDataVisualizations,
    newJob,
    updateJob,
    jobs,
    advertisements,
    jobApplications,
    ceos,
    peerComparisonReport,
    ceoRemunerationComponents,
    remunerationInformations,
    remunerationPolicies,
    boardPolicies,
    listedCompanies,
    yourCompany,
    executiveRisk,
    superAnnuationTab,
    governmentTab,
    otherGovernmentTab,
    notForProfitTab,
    privateCompaniesTab,
    allCompaniesTab,
    form: formReducer,
    router: connectRouter(history),
})
